import { z } from "zod";

// ─── Drivers ─────────────────────────────────────────────────────────────────
export const driverIdSchema = z.string().uuid("ID de chofer inválido");

export const driverStatusEnum = ['active', 'sick', 'on_vacation', 'art', 'suspended'] as const
export type DriverStatus = (typeof driverStatusEnum)[number]

export const createDriverSchema = z.object({
  code:           z.string().min(1, "El código es requerido").max(20),
  name:           z.string().min(1, "El nombre es requerido").max(200),
  sgtCodes:       z.array(z.string().max(200)).nullable().optional(),
  fileId:         z.number().int().nullable().optional(),
  dni:            z.string().max(20).nullable().optional(),
  docTypeId:      z.string().uuid().nullable().optional(),
  docId:          z.string().max(25).nullable().optional(),
  isOwned:        z.boolean().default(false),
  pvcuenta:       z.number().int().nullable().optional(),
  operatorId:     z.string().uuid().nullable().optional(),
  driverStatus:   z.enum(driverStatusEnum).optional(),
  phoneCdc:       z.string().max(50).nullable().optional(),
  phonePersonal:  z.string().max(50).nullable().optional(),
});

export const updateDriverSchema = createDriverSchema.partial();

export const driverQuerySchema = z.object({
  deleted:  z.enum(["true", "false"]).optional(),
  isOwned:  z.enum(["true", "false"]).optional(),
  search:   z.string().optional(),
  page:     z.coerce.number().int().min(1).optional().default(1),
  pageSize: z.coerce.number().int().min(1).max(500).optional().default(25),
});

export const createDriverUserSchema = z.object({
  email:    z.string().email("Email inválido"),
  password: z.string().min(8, "La contraseña debe tener al menos 8 caracteres"),
});

// ─── Exports ───────────────────────────────────────────────────────────
export type DriverId         = z.infer<typeof driverIdSchema>;
export type CreateDriver     = z.infer<typeof createDriverSchema>;
export type UpdateDriver     = z.infer<typeof updateDriverSchema>;
export type DriverQuery      = z.infer<typeof driverQuerySchema>;
export type CreateDriverUser = z.infer<typeof createDriverUserSchema>;
